<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Send notification to the chat</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-layout row wrap justify="center" class="modal-notification">
          <v-flex xs12 sm4 class="modal-notification_field">
            <v-text-field label="Start time" v-model="result.time_from" hint="Format - 15:25"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 class="modal-notification_field">
            <v-text-field
              label="Current time"
              v-model="result.time_to"
              @input="changeTimeFrom"
              hint="Format - 15:25"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 class="modal-notification_field">
            <v-text-field
              label="Total time"
              v-model="duration"
              @input="$emit('childDuration', result.duration)"
              hint="Format - 2h 15m"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-flex xs12 sm12>
          <v-textarea
            hint="Your commits or detailed description"
            label="Description"
            auto-grow rows="1"
            v-model="description"
            @input="$emit('childDescription', newDescription)"
          ></v-textarea>
        </v-flex>
        <v-flex xs12 sm12>
          <v-textarea
            hint="Any useful links, merge requests, comments, etc.."
            label="Useful links"
            auto-grow
            rows="3"
            v-model="urlGitPush"
          ></v-textarea>
        </v-flex>
        <v-flex xs12 sm12>
          <v-textarea
            label="Task URL"
            auto-grow rows="1"
            :value="currentRoute"
            disabled
          ></v-textarea>
        </v-flex>
        <v-card-actions>
          <v-btn block small elevation="2" color="success" @click="close">
            <v-icon class="mr-1" size="18">close</v-icon>
            Close
          </v-btn>
          <v-btn block small elevation="2" color="success" @click="save">
            <v-icon class="mr-1" size="18">save</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'

export default {
  name: 'LogTimeModal',
  props: {
    parentDuration: {
      type: String,
      default: ''
    },
    parentDescription: {
      type: String,
      default: ''
    },
    timesId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      api: this.$api.times,
      dialog: false,
      newDescription: '',
      url: new URL(location.href).toString(),
      urlGitPush: '',
      result: {
        time_to: moment().format('HH:mm'),
        time_from: '',
        duration: '',
        message: ''
      }
    }
  },
  computed: {
    duration: {
      get() {
        this.result.duration = this.parentDuration
        return this.parentDuration ? this.parentDuration : ''
      },
      set(value) {
        this.result.duration = value
      }
    },
    description: {
      get() {
        return this.parentDescription ? this.parentDescription : ''
      },
      set(value) {
        this.newDescription = value
      }
    },
    parseDurationToMilliseconds() {
      let time = this.duration
      let regH = /[0-9]+h/i
      let regM = /[0-9]+m/i
      let hours = parseInt(time.match(regH)) ? parseInt(time.match(regH)) : 0
      let minutes = parseInt(time.match(regM)) ? parseInt(time.match(regM)) : 0
      let millisecondHours = moment.duration(hours, 'hours')
      let millisecondMinutes = moment.duration(minutes, 'minutes')

      return millisecondHours + millisecondMinutes
    },
    currentRoute() {
      if (window.location.origin && window.location.pathname) {
        return `${window.location.origin}${window.location.pathname}`
      }
      return ''
    }
  },
  methods: {
    open() {
      this.dialog = true
      this.result.time_to = moment().format('HH:mm')
      this.changeTimeFrom()
    },
    close() {
      this.dialog = false
    },
    changeTimeFrom() {
      this.result.time_from = moment(this.result.time_to, "HH:mm")
        .subtract(this.parseDurationToMilliseconds, 'ms')
        .format('HH:mm')
    },
    save() {
      this.result.message =
        `${this.description}

${this.urlGitPush}

${this.url}`;

      this.api.storeNotify(this.timesId, this.result).then( () => {
        this.urlGitPush = ''
        this.close()
      }, err => {
        console.log('components/tasks/logTimeModal save', err)
        this.urlGitPush = ''
        this.close()
      });
      this.$emit('deleteForm')
    }
  },
  watch: {
    duration() {
      this.changeTimeFrom()
    }
  }
}
</script>
